import ErrorCone from '../../../assets/empty-state-machines.svg';
import { Button } from '@nexelem/components';
import { t } from 'i18next';
import { ErrorInfo } from 'react';

interface GenericErrorPageProps {
  error?: Error | null;
  errorInfo?: ErrorInfo | null;
}

export const GenericErrorPage = ({ error, errorInfo }: GenericErrorPageProps) => (
  <div className="flex h-full flex-col items-center justify-center overflow-auto pb-8">
    <img
      alt="error cone"
      aria-hidden="true"
      className="mt-12 object-fill"
      height="300"
      role="presentation"
      src={ErrorCone}
      width="324"
    />
    <span className="mt-9 text-s18-sb">{t('errors.genericErrorHeader') || 'Something went wrong.'}</span>
    <span className="mt-2 max-w-[500px] text-center text-s18">
      {t('errors.genericErrorDescription') || 'We are sorry, an error occurred in this part of the application.'}
    </span>
    <span className="mt-4 text-s11-sb text-text-secondary uppercase">{error?.toString()}</span>
    <div className="mt-4 h-32 overflow-auto text-s11-sb whitespace-pre-wrap text-text-secondary">
      {window.location.href} <br />
      {error?.toString()}
      {errorInfo?.componentStack}
    </div>
    <Button className="mt-5 mb-12 shrink-0" variant="outlined" onClick={() => window.location.reload()}>
      {t('common.refreshPage') || 'Refresh page'}
    </Button>
  </div>
);
